export default __webpack_public_path__ + "static/media/sypialnie2.b9bbb11f.jpg";